/**
 * Utilize class so that actions are extendable.
 */
export enum ActionType {
    REQUEST_LIST,
    STORE_LIST,
    ERROR_LIST,
    STORE_BASE_URL,
    UPSERT_FILTER,
    UPDATE_FILTERS,
    REMOVE_FILTER,
    REMOVE_ALL_FILTERS,
    GO_TO_PAGE,
    REQUEST_FILTER_OPTIONS,
    STORE_FILTER_OPTIONS,
    ERROR_FILTER_OPTIONS,
    TRANSITION_MOBILE,
    TRANSITION_DESKTOP,
    NEXT_MONTH,
    PREV_MONTH,
    REQUEST_EVENTS,
    STORE_EVENTS,
    SET_SPECIALTIES_FILTER,
    SET_ZIP_OR_CITY_FILTER,
    SET_GENDER_FILTER,
    SET_LANGUAGE_FILTER,
    SET_HOSPITAL_PRACTICE_FILTER,
    SET_NETWORK_FILTER,
    SET_PRINT_BUTTON,
    SET_PROVIDER_DESIGNATION_FILTER,
    SET_PROVIDER_IMAGES,
    SET_PDF_GENERATION_MESSAGE,
    SET_CITY_FILTER,
    SET_SEARCHWITHIN_TITLE,
    SET_CUSTOM_DISTANCE_ERROR_MESSAGE,
    SET_SHOW_DISTANCE_FILTER,
    SET_ENABLE_ADVANCE_LOCATION_LOOKUP,
}
